import React, { useState } from "react";
import { MapContainer, TileLayer, ZoomControl } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import styles from "./styles_map.module.css";
import { useGetTerritorialUnitsPolygonsListQuery } from "../api";
import { EntTerritorialUnitsFilterPoligons } from "../api/territorialUnitsFilterPoligons";
import { MapProvider } from "./MapContext";
import { ExistingMap } from "./ExistingMap";
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import { SelectYear } from "../selects";

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

interface MapWithPoligonsProps {
  latitude?: number;
  longitude?: number;
  extraData?: any[];
  customIcon?: L.Icon;
  type?: string[];
  selectedYear?: number;
  onYearChange?: (year: number | null) => void;
  onPolygonClick?: (regionId: number) => void;
  selectedRegionId?: number | null;
  showAllDistricts?: boolean;
}

export const MapWithPoligons: React.FC<MapWithPoligonsProps> = ({
  latitude = 41.5089324,
  longitude = 74.724091,
  extraData,
  customIcon,
  type = ["REGION", "AREA", "CITY_OF_REPUBLICAN_SIGNIFICANCE"],
  selectedYear,
  onYearChange,
  onPolygonClick,
  selectedRegionId,
  showAllDistricts
}) => {
  const [isGoogleSatellite, setIsGoogleSatellite] = useState(false);

  const filter = new EntTerritorialUnitsFilterPoligons({
    page: 1,
    size: 60,
    type: type
  });

  const { data: polygonsData, isLoading: polygonsLoading } = useGetTerritorialUnitsPolygonsListQuery(filter);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2019 }, (_, i) => 2020 + i);

  return (
    <MapProvider>
      <div className={styles.map_container}>
        {selectedYear !== undefined && onYearChange && (
          <div className={styles.yearSelectContainer}>
            <SelectYear
              value={selectedYear}
              onChange={onYearChange}
            />
          </div>
        )}
        <div className={styles.layerSwitcher}>
          <button
            className={`${styles.layerButton} ${!isGoogleSatellite ? styles.active : ''}`}
            onClick={() => setIsGoogleSatellite(false)}
          >
            Карта
          </button>
          <button
            className={`${styles.layerButton} ${isGoogleSatellite ? styles.active : ''}`}
            onClick={() => setIsGoogleSatellite(true)}
          >
            Спутник
          </button>
        </div>

        <MapContainer
          center={[latitude, longitude]}
          zoom={7}
          className={styles.map}
          zoomControl={false}
        >
          <ZoomControl position="bottomright" />

          {isGoogleSatellite ? (
            <TileLayer
              url='http://mt1.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}'
              attribution='&copy; <a href="https://www.google.com/maps">Google</a>'
            />
          ) : (
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
          )}

          <ExistingMap 
            polygonsData={polygonsData} 
            polygonsLoading={polygonsLoading} 
            extraData={extraData}
            customIcon={customIcon}
            onPolygonClick={onPolygonClick}
            selectedRegionId={selectedRegionId}
            showAllDistricts={showAllDistricts}
          />
        </MapContainer>
      </div>
    </MapProvider>
  );
};